import { FindingClassType, FindingType } from '../../types';
import { FindingGroup } from '../../findingDetails/findingDetails/types';

export interface EasmRelatedFindingsViewData {
  findingClassType: FindingClassType;
  findingGroups: FindingGroup[];
  findingTypeGroupToFocusOn: FindingType | null;
  searchText: string;
}

export const MIN_NR_CHARS_SEARCH = 3;
